module.exports = __webpack_public_path__ + "static/media/openbook.0aa4e6f4.svg";